function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import Button from 'components/Form/Button';
import Envelope from 'svg/envelope.svg';
import Home from 'svg/home.svg';
import { CONTACT_EMAIL } from '../../../constants';
import styles from './Error.pcss';
var _React_PureComponent;
class Error extends (_React_PureComponent = React.PureComponent) {
    renderSupportButton(code) {
        if (code === 404) {
            return null;
        }
        return /*#__PURE__*/ _jsx("a", {
            href: `mailto:${CONTACT_EMAIL}`,
            type: "link",
            className: "btn btn--quaternary btn--filled text--primary",
            children: /*#__PURE__*/ _jsx("span", {
                className: "btn-inner",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "btn__labelWrapper",
                    children: [
                        /*#__PURE__*/ _jsx(Envelope, {
                            className: "btn__icon mr-2"
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: CONTACT_EMAIL
                        })
                    ]
                })
            })
        });
    }
    render() {
        const { code, codeLabel, title, info, buttonLabel } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: `${styles.error} ${styles[`error--${code}`] || ''}`,
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.errorInfo,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.errorInfo__inner,
                    children: [
                        /*#__PURE__*/ _jsxs("p", {
                            className: styles.errorInfo__errorCode,
                            children: [
                                codeLabel,
                                ": ",
                                code
                            ]
                        }),
                        /*#__PURE__*/ _jsx("h1", {
                            className: styles.errorInfo__errorTitle,
                            children: title
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text--normal text--light mb-5",
                            children: info
                        }),
                        /*#__PURE__*/ _jsxs(Button, {
                            type: "link",
                            to: "/",
                            styleModifier: "quaternary",
                            className: "btn--filled text--primary mr-4",
                            children: [
                                /*#__PURE__*/ _jsx(Home, {
                                    className: "btn__icon mr-2"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    children: buttonLabel
                                })
                            ]
                        }),
                        this.renderSupportButton(code)
                    ]
                })
            })
        });
    }
}
_define_property(Error, "propTypes", {
    // Explicit props
    code: PropTypes.number,
    codeLabel: PropTypes.string,
    title: PropTypes.string,
    info: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    buttonLabel: PropTypes.string
});
export default withStyles(styles)(Error);
